import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";

import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'PickingReport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		download,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			// totalRows:0,
			// currentPage: 0,
			mid: '',
			isLoadingforxls: false,
			csvFieldsForXls: {},
			listReportDataforxls: [],
			formattedDate: '',
			resultCount: '',
			ClientErr: '',
			WarehouseErr: '',
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			pono: '',
			orderid: '',
			searchstatus: '',
			orderstatuslist: [{
				'status': 'created'
			}, {
				'status': 'allocated'
			}, {
				'status': 'picked'
			}, {
				'status': 'packed'
			}, {
				'status': 'dispatched'
			}, {
				'status': 'cancelled'
			}, {
				'status': 'rto'
			},
			{
				'status': 'sr'
			}
			],
			productid: '',
			ProductID: '',
			clientproductid: '',
			rackid: '',
			fromdate: '',
			todate: '',
			user_type: '',
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// perPage: 10,
			// pageno: 0,
			// totalPage: 0,
			isLoading: false,
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			csvFields: [],
			listPickingReportData: [],
			listPickingReportDataCsv: [],
			listClientData: [],
			listWarehouseData: window.localStorage.getItem("selectedZones"),
			channellist: [],
			saleschannel: '',
			userid: '',
			merchantname: '',
			listMerchantData: [],
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			recordLimit: 0,
			limitExeed: false,
			item: {
				value: '',
				text: ''
			},
			listMerchantData1: [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }],
			brand: '',
			activemrpflag:false,
			searchzone:'',
			listZoneData:[],
			rtvType:'',
			boxid:''
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		this.calldateFunction();
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.reportname = this.$t('reports.productivityPickingReportFilename')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		this.getSalesChannels();
		}
		if (localStorage.getItem("selectedWarehouse")!== 'undefined')
		{
			this.getRacksZonesList()
		}
		// this.getRacksZonesList();
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectMerchant = true;
				this.showSelectWarehouse = true;
				// this.getWarehouseList();
				this.getMerchantList();
				this.getActiveMrpFlag();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchantname = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				if (localStorage.getItem("selectedClient")!='undefined')
				{
				this.getActiveMrpFlag();
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getRacksZonesList();
		  });
	},
	methods: {
		zoneslist() {
			console.log(JSON.parse(window.localStorage.getItem("selectedZones")))
			return JSON.parse(window.localStorage.getItem("selectedZones"))
		},
		reset() {
			this.item = {}
		},
		onSelect(item) {
			// select option from parent component
			this.item = item
			this.merchantname = item.value;

		},

		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getPickingReportListForXls(3)
			}
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderSalesChannelList',
				'data': {
					clientid: localStorage.getItem("selectedClient")
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantListArray = [];
						result.data.forEach(function (item) {
							merchantListArray[item.merchantid] = item.merchantname;
						});
						this.merchantList = merchantListArray;
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname

							})
						})
					}
				}, error => {
					console.error(error)
				})
		},
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantname = '';
		// 		if (this.clientid)
		// 			this.getSalesChannels();
		// 		this.getMerchantList();
		// 		this.getActiveMrpFlag();
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getActiveMrpFlag();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.getActiveMrpFlag();
		// 			this.getRacksZonesList()
		// 			// this.getPickingReportList();
		// 		}
		// 	}
		// 	this.getMerchantList()
		// 	this.listPickingReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getSalesChannels();
		// 			this.getRacksZonesList()
		// 		} else {
		// 			this.getClientList();
		// 			this.getRacksZonesList()
		// 		}
		// 	}
		// },
		async getRacksZonesList() {
			try {
				if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
					this.$alertify.error(this.$t('common.warehouseError'))
					this.WarehouseErr = this.$t('common.warehouseError');
					this.pageNo = this.totalPage = 0;
					this.listPickingReportData = [];
					return false;
				}
				this.listZoneData = [];
				this.searchzone = '';
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				if (this.warehouseid) {
					this.isLoading = true
					console.log("kkkkkkkllll");
					this.listZoneData = []
					this.isLoading = true
					var userToken = window.localStorage.getItem('userToken')
					var myStr = userToken.replace(/"/g, '')
					let result = await axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getZonesByWarehouse',
						'data': {
							warehouseid: localStorage.getItem("selectedWarehouse")
						},
						'headers': {
							'Authorization': 'Bearer ' + myStr
						}
					})
					this.listZoneData = result.data.data.data;
					this.isLoading = false
				}
			} catch (err) {
				console.log(err);
			}

		},
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": localStorage.getItem("selectedClient"),
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromdate = dt;
		},
		getPickingReportListSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getPickingReportList();
		},
		//to get client list
		getPickingReportList(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			if (csvCheck == 0) {
				this.show = false;
				this.download = true;
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listPickingReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listPickingReportData = [];
				return false;
			}
			if (csvCheck == 0) {
				this.limitExeed = false
			}
			if (this.orderid == '' && (this.fromdate == '' || this.fromdate == null) && (this.todate == '' || this.todate == null)) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.listPickingReportData = [];
				this.totalRows = 0;
				return false;
			}
			var months;
			var fromDate = new Date(this.fromdate);
			var ToDate = new Date(this.todate);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.orderid == '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listPickingReportData = [];
				return false;
			}


			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}

			// if (csvCheck != 1)
			//this.pageno = 0;

			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				pickqty: this.pickqty,
				productid: this.ProductID,
				orderid: this.orderid,
				rackid: this.rackid,
				fromdate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				saleschannel: this.saleschannel,
				userid: this.userid,
				status: this.searchstatus,
				merchantid: this.merchantname,
				brand: this.brand.trim(),
				zoneid:this.searchzone,
				rtvType:this.rtvType,
				boxid:this.boxid

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPickingReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.listPickingReportDataCsv = [];
							this.show = true;
							this.download = false;
							this.csvFields = {
								'orderid': this.$t('orders.orderId'),
								'productid':  this.$t('common.productId'),
								'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
								'mrp': this.$t('common.mrp'),
								'activemrp': this.$t('common.activemrp'),
								'productname': this.$t('common.productName'),
								'brand': this.$t('common.brandName'),
								'saleschannel':  this.$t('clientChannelMaster.salesChannel'),
								'rackid': this.$t('pickingReport.table.columns.pickRackID') ,
								'pickqty': this.$t('editedjson.pickQuantity'),
								'notfoundqty': this.$t('editedjson.nfQuantity'),
								'boxid': this.$t('common.boxId'),
								'createddatetime':  this.$t('common.createdDate'),
								'picked': this.$t('pickingReport.table.columns.pickedBy'),
								'pickdate': this.$t('pickingReport.table.columns.pickDate'),
								'merchantname': this.$t('merchant.merchantName'),
								'status':  this. $t('common.orderStatus'),
							};
							var dateFilter = [];
							if(this.activemrpflag === true){
								var skipFilter = [];
							}else {
								var skipFilter = ['activemrp'];
							}
							this.listPickingReportDataCsv = result.data.data;
							csvHelper.data.jsonToCSV(this.$t('reports.productivityPickingReportFilename'), this.listPickingReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listPickingReportData = result.data.data;
						if (result.data.errorCode == -1) {
							this.resultCount = 0;
							this.totalRows = 0;
						} else {
							this.totalRows = result.data.count;
							this.resultCount = result.data.count;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows <= this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getPickingReportListForXls(csvCheck = 0) {
			console.log("hello");
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}

			// if (csvCheck != 1)
			//this.pageno = 0;

			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				pickqty: this.pickqty,
				productid: this.ProductID,
				orderid: this.orderid,
				rackid: this.rackid,
				fromdate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				saleschannel: this.saleschannel,
				userid: this.userid,
				merchantid: this.merchantname,
				status: this.searchstatus,
				brand: this.brand.trim(),
				rtvType:this.rtvType,
				boxid:this.boxid

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPickingReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('orders.orderId')] = 'orderid';
								this.csvFieldsForXls[this.$t('common.productId')] = 'productid';
								this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')] = 'eancode';
								this.csvFieldsForXls[this.$t('common.mrp')] = 'mrp';
								if(this.activemrpflag === true){
									this.csvFieldsForXls[this.$t('common.activemrp')] = 'activemrp';
								}
								this.csvFieldsForXls[this.$t('common.productName')] =  'productname';
								this.csvFieldsForXls[this.$t('common.brandName')] = 'brand';
								this.csvFieldsForXls[this.$t('clientChannelMaster.salesChannel')] = 'saleschannel';
								this.csvFieldsForXls[this.$t('pickingReport.table.columns.pickRackID')] = 'rackid';
								this.csvFieldsForXls[this.$t('editedjson.pickQuantity')] = 'pickqty';
								this.csvFieldsForXls[this.$t('editedjson.nfQuantity')] = 'notfoundqty';
								this.csvFieldsForXls[this.$t('common.boxId')] = 'boxid';
								this.csvFieldsForXls[this.$t('common.createdDate')] = 'createddatetime';
								this.csvFieldsForXls[this.$t('pickingReport.table.columns.pickedBy')] = 'picked';
								this.csvFieldsForXls[this.$t('pickingReport.table.columns.pickDate')] = 'pickdate';
								this.csvFieldsForXls[this.$t('merchant.merchantName')] =  'merchantname';
								this.csvFieldsForXls[this.$t('common.orderStatus')] = 'status'


							this.listReportDataforxls = result.data.data;
							// this.listReportDataforxls.forEach(function (entry) {
							// 	if (entry.createddatetime != '' && entry.createddatetime != null) {
							// 		entry.createddatetime = moment(entry.createddatetime).format('YYYY-MM-DD HH:mm:ss');

							// 	}
							// 	if (entry.pickdate != null && entry.pickdate != '') {
							// 		entry.pickdate = moment(entry.pickdate).format('YYYY-MM-DD HH:mm:ss');

							// 	}

							// });
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage;
		// 	this.getPickingReportList();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getPickingReportList()
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.searchzone='';
			this.brand = '';
			this.show = false;
			this.download = true;
			this.orderid = '';
			this.eancode = '';
			this.pickqty = '';
			this.ProductID = '';
			this.merchantname = '',
				this.searchstatus = '',
				this.item = {
					value: '',
					text: ''
				};
			this.rackid = '';
			this.saleschannel = '';
			this.pageno = 0;
			this.totalRows = 0;
			this.listPickingReportData = [];
			this.fromdate = '';
			this.todate = '';
			this.searchFlag = false;
			this.rtvType='';
			this.boxid='';
			//  if (this.user_type == 'warehouse_user') {
			// 	this.client = '';
			// 	// this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
			// }
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
				// this.warehouse = '';
				// this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];

			// }
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/pickingreport/pickingreport.component.js